import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import iconContainerWidgetIcon from "../../assets/images/icon_container_widget.svg";
import IconWidget from "../IconWidget/IconWidgetClass";

Scrivito.provideEditingConfig("IconContainerWidget", {
  title: "Icon List",
  thumbnail: iconContainerWidgetIcon,
  attributes: localizeAttrList(["iconList"], "IconContainerWidget"),
  properties: ["iconList"],
  initialContent: {
    iconList: [
      new IconWidget({ icon: "la-check-square-o" }),
      new IconWidget({ icon: "la-check-square-o" }),
      new IconWidget({ icon: "la-check-square-o" }),
    ],
  },
});
